import {createCarousel} from "./create-carousel";

export function initWebHeaderOuterMenuCarousel()
{
    const root = document.querySelector('#slider-header-outer-menu.header-outer-menu-carousel');
    if (!root || root.classList.contains('is-initialized')) {
        return;
    }

    const slideCount = root.querySelectorAll('.header-outer-menu-carousel__slide').length;
    if (!slideCount) {
        return;
    }

    createCarousel(root, {
        selectors: {
            viewport: '.header-outer-menu-carousel__viewport',
            track: '.header-outer-menu-carousel__track',
            slide: '.header-outer-menu-carousel__slide',
            prev: '.header-outer-menu-carousel__prev',
            next: '.header-outer-menu-carousel__next'
        },
        loop: false,
        mode: 'offset',
        slidesPerView: 1,
        startIndex: 0,
        swipe: true,
        suppressClickOnSwipe: true,
        arrows: {mode: 'toggle-hidden'},
        watchResize: true
    });
}
